export const API_URL = process.env.REACT_APP_API_BASE_URL; //"https://api.onlinenotary.us/dev";
// export const API_URL = "http://localhost:3000/dev";

export const API_STATUS = {
  fulfilled: "fulfilled",
  rejected: "rejected",
};
